const PeriodSelector = ({ setValue, currentSelector }) => {
  const handleClick = (predefineTime) => {
    setValue("currentSelector", predefineTime);
    if (predefineTime !== "custom") {
      const now = new Date();
      const timeRanges = {
        lastWeek: 6,
        lastMonth: 30,
      };
      const days = timeRanges[predefineTime];
      const from = new Date(now.getTime() - days * 24 * 60 * 60 * 1000);
      setValue("from", from);
      setValue("to", now);
    } else {
      setValue("from", "");
      setValue("to", "");
    }
  };

  return (
    <div className="flex gap-2 justify-center py-2">
      {historySelectors.map((item) => {
        return (
          <div
            key={item.type}
            className={`text-[10px] lg:text-sm border-dark-blue border-1 text-dark-blue py-2 px-2 lg:py-[9px] mt-2 cursor-pointer rounded-md hover:bg-[#0F6FDF] hover:text-white hover:border-[#0F6FDF] transition-all duration-300 ${
              currentSelector === item.type ? "bg-[#0F6FDF] text-white border-[#0F6FDF] shadow-100" : ""
            }`}
            onClick={() => handleClick(item.type)}
          >
            {item.name}
          </div>
        );
      })}
    </div>
  );
};

export default PeriodSelector;

export const historySelectors = [
  {
    name: "Last Week",
    type: "lastWeek",
  },
  {
    name: "Last Month",
    type: "lastMonth",
  },
  {
    name: "Custom Date",
    type: "custom",
  },
];
